import { render, staticRenderFns } from "./FollowerNotif.vue?vue&type=template&id=78c88d5f&scoped=true&"
import script from "./FollowerNotif.vue?vue&type=script&lang=js&"
export * from "./FollowerNotif.vue?vue&type=script&lang=js&"
import style0 from "./FollowerNotif.vue?vue&type=style&index=0&id=78c88d5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c88d5f",
  null
  
)

export default component.exports